const isAppleMobileDevice = /iPad|iPhone|iPod/.test(navigator.userAgent);

if (isAppleMobileDevice) {
    const appleMapsLinks = document.querySelectorAll('[data-apple-maps-link]');
    appleMapsLinks.forEach(link => (link.href = link.dataset.appleMapsLink));
}
